// Argus — custom Material UI v6+ theme (dark + light variant).

import { createTheme, type ThemeOptions } from '@mui/material/styles';

const sharedTokens: ThemeOptions = {
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h6: { fontWeight: 600 },
    body2: { lineHeight: 1.45 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: 'none', fontWeight: 500 } },
    },
    MuiTooltip: {
      defaultProps: { arrow: true, disableInteractive: true },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: 'none' } },
    },
  },
};

export const argusDarkTheme = createTheme({
  ...sharedTokens,
  palette: {
    mode: 'dark',
    primary: { main: '#3B82F6' },
    secondary: { main: '#A855F7' },
    success: { main: '#10B981' },
    warning: { main: '#F59E0B' },
    error: { main: '#EF4444' },
    background: { default: '#0F1419', paper: '#1A1F26' },
    divider: 'rgba(255, 255, 255, 0.08)',
  },
});

export const argusLightTheme = createTheme({
  ...sharedTokens,
  palette: {
    mode: 'light',
    primary: { main: '#2563EB' },
    secondary: { main: '#9333EA' },
    success: { main: '#059669' },
    warning: { main: '#D97706' },
    error: { main: '#DC2626' },
    background: { default: '#F8FAFC', paper: '#FFFFFF' },
    divider: 'rgba(0, 0, 0, 0.08)',
  },
});

export type ArgusThemeMode = 'dark' | 'light';

export function getArgusTheme(mode: ArgusThemeMode) {
  return mode === 'light' ? argusLightTheme : argusDarkTheme;
}
